<span
  class="text-sm font-normal aux-link cursor-pointer whitespace-nowrap"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="!!optionalFilters.length && toggleOpenList(!isOpen)"
  [ngClass]="{ 'text-aux-gray-dark-100 cursor-not-allowed': !optionalFilters.length }"
  (auxClickOutside)="toggleOpenList(false)"
>+ Add Filter</span
>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  class="border-solid border-aux-gray-dark-100"
>
  <ul
    tabindex="-1"
    class="bg-white border border-aux-gray-dark text-base overflow-auto mt-2 rounded w-56"
  >
    <ng-container class="grid" *ngFor="let filter of optionalFilters; index as index">
      <li
        class="text-gray-900 cursor-pointer select-none relative flex flex-col p-2.5 hover:bg-aux-gray-light"
        (click)="selectFilter(filter)"
      >
        <p class="font-inter">
          {{ filter }}
        </p>
      </li>
    </ng-container>
  </ul>
</ng-template>
